import {
  Home,
  ShoppingCart,
  Users,
  Layers,
  Package,
  Activity,
  User,
} from "react-feather";
import { BarChart, PiggyBank, FileText, Star, UserCog2Icon } from "lucide-react";

// --- Exclusion logic ---
const exclusionMap = {
  gym: ["Classes", "Coach", "Orders", "Products"],
  academy: ["Orders", "Products", "Gym Management"],
  marketplace: ["Gym Management", "Coach", "Classes"],
};

function getCommonExclusions(types) {
  if (types.length === 0) return [];
  const exclusions = types.map(type => exclusionMap[type] || []);
  return exclusions.reduce((acc, curr) => acc.filter(tab => curr.includes(tab)));
}

// --- Menu items ---
const buildMenuItems = () => {
  const merchantTypesString = localStorage.getItem("merchant-types") || "";
  const merchantTypes = merchantTypesString.split(",").map(t => t.trim()).filter(Boolean);
  const excludedTabs = getCommonExclusions(merchantTypes);

  return [
  {
    menutitle: "General",
    menucontent: "Dashboards, Widgets",
    Items: [
      {
        title: "Profile",
        icon: <User style={{ fill: "none", stroke: "white" }} />,
        iconId: false,
        type: "link",
        path: `${process.env.PUBLIC_URL}/merchant/profile`,
      },
      {
        title: "Dashboard",
        icon: <Home style={{ fill: "none", stroke: "white" }} />,
        iconId: false,
        type: "link",
        path: `${process.env.PUBLIC_URL}/pages/dashboard`,
      },
      {
        title: "Gym Management",
        icon: <Users style={{ fill: "none", stroke: "white" }} />,
        iconId: false,
        type: "sub",
        children: [
          {
            title: "Gym Plans",
            path: `${process.env.PUBLIC_URL}/subscription/plans`,
            type: "link",
          },
          {
            title: "Subscribers",
            path: `${process.env.PUBLIC_URL}/subscription/subscribers`,
            type: "link",
          },
        ],
      },
      {
        title: "My-Subscriptions",
        icon: <PiggyBank style={{ fill: "none", stroke: "white" }} />,
        iconId: false,
        type: "link",
        path: `${process.env.PUBLIC_URL}/subscriptions/my-subscriptions`,
      },
      {
        title: "Classes",
        icon: <Layers style={{ fill: "none", stroke: "white" }} />,
        iconId: false,
        type: "link",
        path: `${process.env.PUBLIC_URL}/classes/class-management`,
      },
      {
        title: "Coach",
        icon: <UserCog2Icon style={{ fill: "none", stroke: "white" }} />,
        iconId: false,
        type: "link",
        path: `${process.env.PUBLIC_URL}/pages/coach`,
      },
      {
        title: "Products",
        icon: <Package style={{ fill: "none", stroke: "white" }} />,
        iconId: false,
        type: "link",
        path: `${process.env.PUBLIC_URL}/products/product-management`,
      },
      {
        title: "Orders",
        icon: <ShoppingCart style={{ fill: "none", stroke: "white" }} />,
        iconId: false,
        type: "link",
        path: `${process.env.PUBLIC_URL}/page/orders`,
      },
      {
        title: "Analytics",
        icon: <FileText style={{ fill: "none", stroke: "white" }} />,
        iconId: false,
        type: "link",
        path: `${process.env.PUBLIC_URL}/revenue/analytics`,
      },
      {
        title: "Finance",
        icon: <BarChart style={{ fill: "none", stroke: "white" }} />,
        iconId: false,
        type: "link",
        path: `${process.env.PUBLIC_URL}/finance/finance-management`,
      },
      {
        title: "Marketing",
        icon: <Activity style={{ fill: "none", stroke: "white" }} />,
        iconId: false,
        type: "link",
        path: `${process.env.PUBLIC_URL}/marketing/marketing-management`,
      },
      {
        title: "Reviews",
        icon: <Star style={{ fill: "none", stroke: "white" }} />,
        iconId: false,
        type: "link",
        path: `${process.env.PUBLIC_URL}/review/reviews`,
      },
      {
        title: "FAQ's",
        icon: <Star style={{ fill: "none", stroke: "white" }} />,
        iconId: false,
        type: "link",
        path: `${process.env.PUBLIC_URL}/page/faq's`,
      },
    ].filter(item => !excludedTabs.includes(item.title)),
  },
  ];
};

// Live binding: `merchant-types` is rewritten after login/profile fetch (the
// login flow clears localStorage and SPA-navigates), so a one-shot module-level
// build would go stale. Layout calls refreshMenuItems() once the profile is
// loaded, before any menu consumer mounts.
export let MENUITEMS = buildMenuItems();

export const refreshMenuItems = () => {
  MENUITEMS = buildMenuItems();
  return MENUITEMS;
};
